import http from '../../app/services/httpServices';
import URL_UTILITY from '../../app/utility/url.utility';

const getPendingInvSyncCount = (context, payload) => {
  return http.getApi(
    URL_UTILITY.getRealAppDashboardUrl + '/vendor-dashboard-po-count',
    payload
  );
};
const getPendingInvSyncData = (context, payload) => {
  return http.getApi(
    URL_UTILITY.getRealAppDashboardUrl + '/vendor-dashboard-po',
    payload
  );
};
const getPendingGrnSyncCount = (context, payload) => {
  return http.getApi(
    URL_UTILITY.getRealAppDashboardUrl + '/grn-approved-buyer-count',
    payload
  );
};
const getPendingGrnSyncData = (context, payload) => {
  return http.getApi(
    URL_UTILITY.getRealAppDashboardUrl + '/grn-approved-buyer',
    payload
  );
};
const getPendingRecDocCount = (context, payload) => {
  return http.getApi(
    URL_UTILITY.getRealAppDashboardUrl + '/grn-flag-count',
    payload
  );
};
const getPendingRecDocData = (context, payload) => {
  return http.getApi(URL_UTILITY.getRealAppDashboardUrl + '/grn-flag', payload);
};
const getPendingPoSyncData = (context,payload) => {
  return http.getApi(URL_UTILITY.getRfpAdminUrl + '/rfp-to-po-creation-header-dashboard',payload)
}
const getPendingPoSyncCount = (context,payload) => {
  return http.getApi(URL_UTILITY.getRfpAdminUrl + '/rfp-to-po-creation-count-dashboard',payload)
}
export default {
  getPendingInvSyncCount,
  getPendingInvSyncData,
  getPendingGrnSyncCount,
  getPendingGrnSyncData,
  getPendingRecDocCount,
  getPendingRecDocData,
  getPendingPoSyncData,
  getPendingPoSyncCount
};
